import React, { useMemo } from "react";
import { format, isSameDay, parseISO } from "date-fns";
import { Link } from "react-router-dom";
import { VenueSession } from "../../app/types";
import now from "../../util/now";
import useVenueId from "../common/useVenueId";

interface Props {
  index: number;
  lastIndex: number;
  session: VenueSession;
}

const PresentationReminderItem = ({ index, lastIndex, session }: Props) => {
  const venueId = useVenueId();
  const { sessionId, startTime } = session;
  const to = useMemo(
    () => ({ pathname: `/${venueId}/session/${sessionId}` }),
    [sessionId, venueId],
  );

  return (
    <>
      {index === lastIndex ? <> and</> : null}{" "}
      <Link className="timeLink" to={to}>
        {" "}
        {format(parseISO(startTime), "h:mmaaaaa")}{" "}
      </Link>
      {isSameDay(new Date(startTime), now) ? <> today</> : <> tomorrow</>}
      {index < lastIndex && <>, </>}
    </>
  );
};

export default PresentationReminderItem;
